<form [formGroup]="formGroup">
  <timepicker
    formControlName="{{controlName}}"
    [minuteStep]="1"
    [showMeridian]="false">
  </timepicker>
</form>
